module.exports = __webpack_public_path__ + "static/media/applogo.62341b4a.png";